(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $565b60e1bcdc0fe8$var$SvgSafariPinnedTab = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 373.333,
        height: 373.333,
        viewBox: "0 0 280 280",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M9.5 1.4C5.4 3.2 1.2 8.3.5 12.3.2 14.1.1 72.7.2 142.7c.3 126.6.3 127.2 2.4 129.9 1.1 1.5 3.3 3.7 4.8 4.8 2.7 2.1 3 2.1 132.6 2.1s129.9 0 132.6-2.1c1.5-1.1 3.7-3.3 4.8-4.8 2.1-2.7 2.1-3 2.1-132.6s0-129.9-2.1-132.6c-1.1-1.5-3.3-3.7-4.8-4.8C269.9.5 269.4.5 141.2.3 35.7.1 11.9.3 9.5 1.4zM167 73.6c9.8 2.9 18.1 10.1 22.4 19.3 3 6.6 3 20.6-.1 27.3-3 6.6-10.5 14.3-17.2 17.5-4.9 2.4-6.8 2.8-14.7 2.8-8.2 0-9.6-.3-15.6-3.3l-6.6-3.4-5.8 3.9-5.9 3.9-.3 33.7-.2 33.7 26.2.2c22.6.3 26.3.5 26.3 1.8s-5.5 1.5-42.7 1.8C90.5 213 90 213 90 211c0-1.6.7-2 3.5-2s5.2-1.3 11-5.6c4.1-3.1 7.5-6.2 7.5-6.8 0-.6-2-4-4.3-7.6-4.7-7-15.7-25.8-15.7-26.8 0-.3-.7-1.3-1.6-2.3-1.4-1.6-1.3-2.1 2.2-6.1 2.1-2.3 10.3-10.9 18.2-18.9l14.5-14.7-1.3-5.2c-6.2-25.7 17.9-48.9 43-41.4z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M113.2 148c-3.5 2.2-8.9 5.3-12.1 6.9-8.9 4.5-8.9 4.8-4 13.3 2.3 4 7.1 11.9 10.6 17.5 4.3 6.8 6.3 10.8 5.9 12-.4 1-3.4 3.8-6.9 6.3l-6.2 4.5 9.4.3c5.1.1 9.5.1 9.7-.1.3-.2.3-14.9.2-32.6l-.3-32.2-6.3 4.1z"
            })
        ]
    });
var $565b60e1bcdc0fe8$export$2e2bcd8739ae039 = $565b60e1bcdc0fe8$var$SvgSafariPinnedTab;

})();
//# sourceMappingURL=safari-pinned-tab.9c5d8f56.js.map
